var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "contactForm" };
const _hoisted_2 = {
    class: "row",
    id: "contact_us_content"
};
const _hoisted_3 = { class: "col-12 col-md-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "text-left font8-responsive d-md-block d-none" }, [
    /*#__PURE__*/ _createTextVNode(" Hier findest du unsere "),
    /*#__PURE__*/ _createElementVNode("a", {
        href: "/datenschutz",
        _target: "blank",
        title: "Datenschutzbestimmungen",
        class: "link-in-text"
    }, " Datenschutzerklärung "),
    /*#__PURE__*/ _createElementVNode("div", { class: "font8-responsive text-left pt-3" }, "* Pflichtangabe")
], -1);
const _hoisted_5 = { class: "col-12 col-md-6 mb-md-3 mb-0" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "text-left font8-responsive pt-2 d-md-none d-block" }, [
    /*#__PURE__*/ _createTextVNode(" Hier findest du unsere "),
    /*#__PURE__*/ _createElementVNode("a", {
        href: "/datenschutz",
        target: "_blank",
        title: "Datenschutzbestimmungen",
        class: "link-in-text"
    }, " Datenschutzerklärung "),
    /*#__PURE__*/ _createElementVNode("div", { class: "font8-responsive text-left pt-3" }, "* Pflichtangabe")
], -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("hr", { class: "rule mb-3 mt-1 py-0" }, null, -1);
const _hoisted_8 = { class: "row pb-4" };
const _hoisted_9 = { class: "col-12 mt-lg-0 mt-3" };
const _hoisted_10 = ["disabled"];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("i", { class: "icon-rocket" }, null, -1);
import BaseInput from '@/components/Base/Forms/Inputs/BaseInput.vue';
import BaseEmailInput from '@/components/Base/Forms/Inputs/BaseEmailInput.vue';
import { emailRequiredRule, firstNameRule, lastNameRule, stringRequiredRule } from '@/helpers/ValidationRules';
import { ref, computed } from 'vue';
import axios from 'axios';
import { useReCaptcha } from 'vue-recaptcha-v3';
import BaseTextArea from '@/components/Base/Forms/Inputs/BaseTextArea.vue';
import eventBus from '@/services/EventBus';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default /*#__PURE__*/ _defineComponent({
    __name: 'ContactForm',
    setup(__props) {
        const { executeRecaptcha } = useReCaptcha();
        const firstName = ref('');
        const lastName = ref('');
        const email = ref('');
        const subject = ref('');
        const message = ref('');
        // Inputs valid:
        const firstNameValid = ref(false);
        const lastNameValid = ref(false);
        const emailValid = ref(false);
        const subjectValid = ref(false);
        const submitPossible = computed(() => {
            return firstNameValid.value && lastNameValid.value && emailValid.value && subjectValid.value;
        });
        const send = () => __awaiter(this, void 0, void 0, function* () {
            const token = yield executeRecaptcha();
            if (!submitPossible.value) {
                return;
            }
            axios
                .post('/contactsend', {
                'g-recaptcha-response': token,
                type: 'basic',
                first_name: firstName.value,
                last_name: lastName.value,
                email: email.value,
                subject: subject.value,
                message: message.value,
            })
                .then(() => {
                eventBus.emit('openInfoPopup', {
                    icon: 'success',
                    headline: 'Versandbestätigung',
                    message: 'Danke für Deine Nachricht!',
                });
            })
                .catch((error) => {
                let serverResponseErrors = '';
                Object.values(error.response.data.errors).forEach((e) => {
                    serverResponseErrors += e;
                    serverResponseErrors += '<br>';
                });
                eventBus.emit('openInfoPopup', {
                    icon: 'error',
                    headline: 'Da ging was schief',
                    message: serverResponseErrors,
                });
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(BaseInput, {
                            class: "showValidationErrorsCssOverride mb-3",
                            rules: _unref(firstNameRule),
                            modelValue: firstName.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((firstName).value = $event)),
                            placeholder: "Vorname *",
                            name: "firstName",
                            onChanged: _cache[1] || (_cache[1] = (event) => (firstNameValid.value = event.valid))
                        }, null, 8, ["rules", "modelValue"]),
                        _createVNode(BaseInput, {
                            class: "showValidationErrorsCssOverride mb-3",
                            rules: _unref(lastNameRule),
                            modelValue: lastName.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((lastName).value = $event)),
                            placeholder: "Nachname *",
                            name: "lastName",
                            onChanged: _cache[3] || (_cache[3] = (event) => (lastNameValid.value = event.valid))
                        }, null, 8, ["rules", "modelValue"]),
                        _createVNode(BaseEmailInput, {
                            class: "showValidationErrorsCssOverride mb-3",
                            rules: _unref(emailRequiredRule),
                            modelValue: email.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((email).value = $event)),
                            placeholder: "E-Mail *",
                            label: "E-Mail",
                            id: "email",
                            name: "email",
                            onChanged: _cache[5] || (_cache[5] = (event) => (emailValid.value = event.valid))
                        }, null, 8, ["rules", "modelValue"]),
                        _hoisted_4
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(BaseInput, {
                            class: "showValidationErrorsCssOverride mb-3",
                            rules: _unref(stringRequiredRule),
                            modelValue: subject.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((subject).value = $event)),
                            placeholder: "Betreff *",
                            name: "subject",
                            onChanged: _cache[7] || (_cache[7] = (event) => (subjectValid.value = event.valid))
                        }, null, 8, ["rules", "modelValue"]),
                        _createVNode(BaseTextArea, {
                            name: "Message",
                            label: "Deine Nachricht",
                            placeholder: "Deine Nachricht",
                            modelValue: message.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((message).value = $event))
                        }, null, 8, ["modelValue"]),
                        _hoisted_6
                    ])
                ]),
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("button", {
                            disabled: !submitPossible.value,
                            class: _normalizeClass([{ buttonDisabled: !submitPossible.value }, "buttonBase buttonBlue w-100"]),
                            type: "button",
                            onClick: send
                        }, [
                            _hoisted_11,
                            _createTextVNode(" Abschicken ")
                        ], 10, _hoisted_10)
                    ])
                ])
            ]));
        };
    }
});
